export function loadJS(url, callback) {
  const script = document.createElement('script');
  const fn = callback || function() {};

  script.type = 'text/javascript';
  script.onload = function() {
    fn();
  };
  script.src = url;

  document.getElementsByTagName('head')[0].appendChild(script);
}

export function generateBaseDomain() {
  const JENKINS_PROJ_NAME = 'chatbot';
  const platform = process.env.platform;
  const isBank = ['bank', 'bankID', 'bankSG'].includes(platform);
  const bankCdnMap = {
    bank: 'https://chatbot.seabank.ph/',
    bankID: 'https://chatbot.seabank.co.id/',
    bankSG: 'https://chatbot.maribank.com.sg/',
  };
  const cdnServedPath = isBank ? bankCdnMap[platform] : `https://cs.deo.shopeemobile.com/shopee/shopee-${JENKINS_PROJ_NAME}-live-${COUNTRY}/`;
  const buildPath = '/';
  const isLive = (ENVIRONMENT || process.env.environment) === 'live';
  return isLive ? cdnServedPath : buildPath;
}
